var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 178 129",
    style: {
      enableBackground: "new 0 0 178 129"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000031891125580916816410000013944403634980685716_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M135.7,77.5c0.1,22-8,37.4-25.6,46.8c-15.7,8.3-38.9,5.4-52.3-8.1S42,82.7,42.3,66.7c0.3-13,5-25.3,11.3-36.6 c3.8-6.9,8-13.5,14-19.1c1.2-1.1,4.9-1.2,6.9-0.4c2.7,1.1,5.1,3,6.7,5.4c4.9,8.4,13.3,12.3,20.7,17.7c4.6,3.3,8.2,8,12.3,12 s8.7,9,13.4,13C134.1,64.5,136,70.5,135.7,77.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M130.6,43.1c-7.8,0.4-13.2-3.7-18.6-7.6c-3.6-2.6-7.4-4.9-11.3-7.1c-5.7-3-11.2-5.8-15-11.5 c-3-4.3-7.7-7.5-11.6-11.2c8.3-7.4,19.9-7.2,28.3-1.9C116.8,12.8,125.2,26.6,130.6,43.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d9fd3607535206e89d3108a8713f3ca9.svg";
export { ForwardRef as ReactComponent };